(function () {
  window.allerasImages = {
    withWidth: function (url, width) {
      if (!url) return '';

      try {
        var parsed = new URL(url, window.location.href);
        parsed.searchParams.set('width', String(width));
        return parsed.href;
      } catch (error) {
        if (/[?&]width=\d+/.test(url)) {
          return url.replace(/([?&])width=\d+/, '$1width=' + width);
        }

        return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width;
      }
    },
    srcset: function (url, widths) {
      if (!url || !widths || !widths.length) return '';

      return widths
        .map(function (width) {
          return window.allerasImages.withWidth(url, width) + ' ' + width + 'w';
        })
        .join(', ');
    },
    productCard: function (url) {
      return window.allerasImages.srcset(url, [352, 640, 832, 1200, 1600, 1920, 2560]);
    },
    gallery: function (url) {
      return window.allerasImages.srcset(url, [433, 640, 866, 1200, 1600, 2000, 2560, 3840]);
    }
  };
})();
